import React from 'react'

export default function FeedbackItem(props) {
    var text = props.text;
    var date = props.date;
    const formatDate = function(d){
        var date = new Date(d);
        var res = '';
        var dd = String(date.getDate()).padStart(2, '0');
        var mm = String(date.getMonth() + 1);
        var yyyy = date.getFullYear();
        res = mm+'-'+dd+'-'+yyyy;
        return res
    }

    return (
        <div>
            <p>
            •  {text}
                <span className='fst-italic'> ({formatDate(date)})</span>
            </p>
        </div>
    )
}
